import { ButtonV2 } from '@synoptic/ui-kit/button-v2/button-v2.js';
import { useState } from 'react';
import { customStreamTutorialVideo } from '@/routes/_app.p.learning-center/custom-stream-tutorial-video.ts';
import { LearningVideoModal } from '@/routes/_app.p.learning-center/learning-video-modal.tsx';
import {
  customStreamExplainerBodyV2,
  customStreamExplainerCopyV2,
  customStreamExplainerTitleV2,
  customStreamExplainerV2,
} from './stream-page-v2.css.ts';

export const CustomStreamExplainerV2 = () => {
  const [tutorialOpen, setTutorialOpen] = useState(false);

  return (
    <div className={customStreamExplainerV2}>
      <div className={customStreamExplainerCopyV2}>
        <p className={customStreamExplainerTitleV2}>
          Custom streams let you control the feed.
        </p>
        <p className={customStreamExplainerBodyV2}>
          You define the data you want to track. Provide your own targets, and
          this stream will monitor them, delivering real-time updates tailored
          to your needs.
        </p>
      </div>
      <ButtonV2
        type="button"
        variant="secondary"
        onClick={() => setTutorialOpen(true)}
      >
        Watch tutorial
      </ButtonV2>
      <LearningVideoModal
        video={tutorialOpen ? customStreamTutorialVideo : null}
        onClose={() => setTutorialOpen(false)}
      />
    </div>
  );
};
